import React from "react";
import Subscriber from "./subscriber";

export default function HpWalkthrough() {
  return (
    <div>
      <Subscriber />
    </div>
  );
}
